import { apiClient } from '@/api/client'
import type { Consolidation, ConsolidationDetail, ConsolidationProgress } from './types'

export async function fetchConsolidations(): Promise<Consolidation[]> {
  const { data } = await apiClient.get<{ success: boolean; data: Consolidation[] }>(
    '/portal/consolidation/api/list',
  )
  return data.data
}

export async function fetchConsolidationDetail(id: number): Promise<ConsolidationDetail> {
  const { data } = await apiClient.get<ConsolidationDetail>(`/portal/consolidation/api/${id}`)
  return data
}

export async function createConsolidation(params: {
  primary_controller_id: string
  secondary_controller_id: string
}): Promise<Consolidation> {
  const { data } = await apiClient.post<{ success: boolean; message: string; consolidation: Consolidation }>(
    '/portal/consolidation/api/create',
    params,
  )
  return data.consolidation
}

export async function deactivateConsolidation(id: number): Promise<void> {
  await apiClient.post(`/portal/consolidation/api/${id}/deactivate`)
}

export async function reactivateConsolidation(id: number): Promise<void> {
  await apiClient.post(`/portal/consolidation/api/${id}/reactivate`)
}

export async function deleteConsolidation(id: number): Promise<void> {
  await apiClient.delete(`/portal/consolidation/api/${id}`)
}

export async function reloadConsolidated(controllerId: string): Promise<void> {
  await apiClient.post(`/portal/consolidation/api/${controllerId}/reload-consolidated`)
}

export async function fetchConsolidationProgress(controllerId: string): Promise<ConsolidationProgress> {
  const { data } = await apiClient.get<{ success: boolean; progress: ConsolidationProgress }>(
    `/portal/consolidation/api/${controllerId}/progress`,
  )
  return data.progress
}
